import Header from '../components/shared/Header'
import Footer from '../components/shared/Footer'
import Hero from '../components/landing/Hero'
import HowToRead from '../components/landing/HowToRead'
import ExperimentsList from '../components/landing/ExperimentsList'
import ToolsList from '../components/landing/ToolsList'
import Context from '../components/landing/Context'
import MetaTags from '../components/shared/MetaTags'
import StructuredData from '../components/shared/StructuredData'

export default function LandingPage() {
  return (
    <>
      <MetaTags
        title="deedslab.com"
        description="Strategy is intent. Action is the test. Explore a personal laboratory of experiments, simulations, and learnings from real-world strategic testing."
        url="/"
        type="website"
      />
      <StructuredData
        type="WebSite"
        title="deedslab.com"
        description="Strategy is intent. Action is the test. Explore a personal laboratory of experiments, simulations, and learnings from real-world strategic testing."
        url="/"
      />
      <div
        className="min-h-screen"
        style={{
          background: 'radial-gradient(900px 520px at 20% -10%, rgba(122, 215, 255, 0.18), transparent 58%)'
        }}
      >
      <div className="max-w-container mx-auto px-5 md:px-8 py-7 pb-20">
        <Header />
        <Hero />
        <HowToRead />
        <ExperimentsList />
        <ToolsList />
        <Context />
        <Footer />
      </div>
    </div>
    </>
  )
}

